import { View } from '../../components/view'

/**
 * Базовая вью для затемнения экрана под попапом.
 */
export class FaderBaseView extends View {
  /**
   * Включение/выключение (переопределяется в потомках)
   */
  toggle () {
  }

  /**
   * Показать (переопределяется в потомках)
   */
  show () {
  }

  /**
   * Скрыть (переопределяется в потомках)
   */
  hide () {
  }
}
